export const SEARCH_TYPE_IDS = {
  CLAIM: 'CLAIM',
  REGISTER: 'REGISTER',
  POLICY: 'POLICY',
  ASSURED_CIN: 'ASSURED_CIN',
  ASSURED_NAME: 'ASSURED_NAME',
  VICTIM_NAME: 'VICTIM_NAME',
  COURT_FILE_NUMBER: 'COURT_FILE_NUMBER',
  PRE_OPEN_DATE: 'PRE_OPEN_DATE',
  DEFAULT_LAWYER_ASSIGNMENT: 'DEFAULT_LAWYER_ASSIGNMENT',
  CLAIM_NUMBER: 'CLAIM_NUMBER',
  CIN_ASSURE: 'CIN_ASSURE',
  FULL_NAME_ASSURE: 'FULL_NAME_ASSURE',
  REF_ATTESTATION: 'REF_ATTESTATION',
};

export const SEARCH_QUERY_INIT_VALUES = {
  lossDate: null,
  registrationNumber: null,
  policyNumber: null,
  claimNumber: null,
  assuredCIN: null,
  assuredName: null,
  victimName: null,
  courtNumber: null,
  procedureNatureId: 0,
  jurisdictionDegreeId: null,
  jurisdiction: null,
  cinAssure: null,
  firstName: null,
  lastName: null,
  refAttestation: null,
};
export const SEARCH_BAR_TYPES = {
  DEFAULT: 'default',
  SHOW_OTHER: 'showOther',
};
